
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { UserItemProps } from ".";
import { loading, index, options } from "store/user";

interface ApiUserInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
    roleIds?: number[];
    departmentIds?: number[];
    positionIds?: number[];
    specialtyIds?: number[];
}

type ApiUserOutputProps = OutputBaseProps<{ list: UserItemProps[]; pagination?: PaginationProps; }>;

export const apiUserIndex = async (data: ApiUserInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiUserOutputProps>("/api/users", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiUserOptions = async (data: { q?: string }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiUserOutputProps>("/api/users", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};